import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastIcon,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from '@/components/ui/Toast';
import { useToast } from '@/hooks/useToast';

/**
 * Mount once near the app root (in `App.tsx` or `main.tsx`). Renders the
 * imperative toast queue from `@/hooks/useToast`.
 */
export function Toaster() {
  const { toasts, dismiss } = useToast();
  return (
    <ToastProvider swipeDirection="right">
      {toasts.map((t) => (
        <Toast
          key={t.id}
          variant={t.variant}
          duration={t.duration ?? 4000}
          onOpenChange={(open) => {
            if (!open) dismiss(t.id);
          }}
        >
          <ToastIcon variant={t.variant} />
          <div className="flex-1 flex flex-col gap-xs">
            <ToastTitle>{t.title}</ToastTitle>
            {t.description ? <ToastDescription>{t.description}</ToastDescription> : null}
          </div>
          <ToastClose />
        </Toast>
      ))}
      <ToastViewport />
    </ToastProvider>
  );
}
